export const DESKTOP_NAV_HEIGHT = "180px"
export const MOBILE_NAV_HEIGHT = "136px"
